import { render } from "./NewLoginScreen.vue?vue&type=template&id=619d97b1&scoped=true"
import script from "./NewLoginScreen.vue?vue&type=script&lang=js"
export * from "./NewLoginScreen.vue?vue&type=script&lang=js"

import "./NewLoginScreen.vue?vue&type=style&index=0&id=619d97b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619d97b1"]])

export default __exports__